import type React from 'react'

import { TeamConversationView } from '@/components/templates/TeamConversationView/TeamConversationView.tsx'

import { useTeamMessagesWithoutTeamPage } from './useTeamMessagesWithoutTeamPage.ts'

export const TeamMessagesWithoutTeamPage: React.FC = () => {
  const props = useTeamMessagesWithoutTeamPage()

  return <TeamConversationView {...props} />
}
